module.exports = __webpack_public_path__ + "static/images/58c9c5dbcbf58dc56387a792a05cb4a3.webp";